import { render, staticRenderFns } from "./NavHeader.vue?vue&type=template&id=3f1547c4&scoped=true&"
import script from "./NavHeader.vue?vue&type=script&lang=js&"
export * from "./NavHeader.vue?vue&type=script&lang=js&"
import style0 from "./NavHeader.vue?vue&type=style&index=0&id=3f1547c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1547c4",
  null
  
)

export default component.exports